import moment from "moment";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { showError, showSuccess } from "../../helpers/Toast";
import { Header } from "../../components";
import { createIzin, getStatusIzin } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";

const Izin = () => {
  const navigate = useNavigate();
  const [keterangan, setketerangan] = useState("");
  const [jenisizin, setjenisizin] = useState([]);
  const defaultOption = jenisizin[0];
  const [tglawal, settglawal] = useState(new Date());
  const [tglakhir, settglakhir] = useState(new Date());
  const [file, setFile] = useState();
  const [jumlahhari, setjumlahhari] = useState("");
  const [jenisizin_id, setjenisizin_id] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("jenisizin_id", jenisizin_id === "" ? jenisizin[0]?.id : jenisizin_id);
    body.append("tanggal_awal", moment(tglawal).format("YYYY-MM-DD"));
    body.append("tanggal_akhir", moment(tglakhir).format("YYYY-MM-DD"));
    body.append("jumlah_hari", jumlahhari);
    body.append("keterangan", keterangan);
    body.append("bukti", file);

    try {
      setIsSubmitting(true);
      const response = await fetch(createIzin, {
        method: "POST",
        mode: "cors",
        headers: { Authorization: `Bearer ${token}` },
        body: body,
      });

      if (!response.ok) {
        const errorData = await response.json();
        showError(JSON.stringify(errorData.message).replace(/["{}]/g, "").replace(/:/, ": "));
        return;
      }
      showSuccess("Izin berhasil diajukan");
      navigate("/home");
    } catch (error) {
      showError("Izin gagal diajukan");
    } finally {
      setIsSubmitting(false);
    }
  };

  function handleChange(event) {
    setFile(event.target.files[0]);
  }

  const getstatus = async () => {
    try {
      const response = await fetch(getStatusIzin, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        showError("Gagal memuat jenis izin");
        return;
      }

      const data = await response.json();
      const status = data.data.map((item) => ({
        id: item.jenisizin_id,
        label: item.nama_jenisizin,
        value: item.nama_jenisizin,
      }));
      setjenisizin(status);
    } catch (error) {
      showError("Gagal mengambil data jenis izin");
    }
  };

  const onselectstatus = (data) => {
    const objek = jenisizin.find((item) => item.value === data.value);
    setjenisizin_id(objek.id);
  };

  useEffect(() => {
    getstatus();
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Helmet>
        <title>Pengajuan Izin</title>
      </Helmet>

      <div
        className="w-full px-4 pt-6 pb-14"
        style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
      >
        <Header to="/home" title="Pengajuan Izin" />
      </div>

      <div className="flex-grow px-4 pb-6" style={{ marginTop: -40 }}>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-4 space-y-4">
            {/* Jenis Izin */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Jenis Izin</label>
              <Dropdown
                options={jenisizin}
                onChange={onselectstatus}
                value={defaultOption}
                placeholder="Pilih Jenis Izin"
                className="rounded-xl"
              />
            </div>

            {/* Tanggal */}
            <div className="flex gap-3">
              <div className="flex-1">
                <label className="block text-xs font-semibold text-gray-500 mb-1.5">Tanggal Awal</label>
                <DatePicker
                  className="w-full text-sm text-gray-700 bg-gray-50 rounded-xl px-3 py-2.5 border border-gray-200 focus:outline-none"
                  selected={tglawal}
                  onChange={(date) => settglawal(date)}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
              <div className="flex-1">
                <label className="block text-xs font-semibold text-gray-500 mb-1.5">Tanggal Akhir</label>
                <DatePicker
                  className="w-full text-sm text-gray-700 bg-gray-50 rounded-xl px-3 py-2.5 border border-gray-200 focus:outline-none"
                  selected={tglakhir}
                  onChange={(date) => settglakhir(date)}
                  dateFormat="dd/MM/yyyy"
                />
              </div>
            </div>

            {/* Jumlah Hari */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Jumlah Hari</label>
              <input
                value={jumlahhari}
                onChange={(e) => setjumlahhari(e.target.value)}
                type="number"
                placeholder="Masukkan jumlah hari"
                className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 focus:border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400/30"
              />
            </div>

            {/* Keterangan */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Keterangan</label>
              <textarea
                value={keterangan}
                onChange={(e) => setketerangan(e.target.value)}
                placeholder="Masukkan keterangan izin"
                rows={3}
                className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-800 focus:border-yellow-400 focus:outline-none focus:ring-2 focus:ring-yellow-400/30 resize-none"
              />
            </div>

            {/* Upload Dokumen */}
            <div>
              <label className="block text-xs font-semibold text-gray-500 mb-1.5">Upload Dokumen</label>
              <div className="border-2 border-dashed border-gray-200 rounded-xl p-4 text-center bg-gray-50">
                <input type="file" onChange={handleChange} className="w-full text-sm text-gray-500" />
                <p className="text-xs text-gray-400 mt-1">PDF, JPG, PNG (maks 5MB)</p>
              </div>
            </div>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full flex items-center justify-center gap-2 rounded-2xl py-3.5 text-sm font-bold text-white shadow-md transition active:scale-95 disabled:opacity-70"
            style={{ background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)" }}
          >
            {isSubmitting ? (
              <>
                <svg className="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
                </svg>
                Menyimpan...
              </>
            ) : "Ajukan Izin"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Izin;
